import { Mail, Phone, Star, ClipboardList, ShoppingCart, Briefcase, CreditCard, FileText } from "lucide-react";
import type { LucideIcon } from "lucide-react";

export function greeting(): string {
  const h = new Date().getHours();
  if (h < 12) return "Good morning";
  if (h < 18) return "Good afternoon";
  return "Good evening";
}

export function timeAgo(iso: string): string {
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return "";
  const seconds = Math.floor((Date.now() - then) / 1000);
  if (seconds < 60) return "just now";
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes} min ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} hour${hours === 1 ? "" : "s"} ago`;
  const days = Math.floor(hours / 24);
  if (days < 7) return `${days} day${days === 1 ? "" : "s"} ago`;
  return new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric" });
}

const ICON_KEYWORDS: [RegExp, LucideIcon][] = [
  [/contact|phone|call/i, Phone],
  [/newsletter|email|subscribe/i, Mail],
  [/feedback|review|rating/i, Star],
  [/survey|questionnaire/i, ClipboardList],
  [/order|purchase|checkout/i, ShoppingCart],
  [/job|application|career/i, Briefcase],
  [/payment|donation|donate/i, CreditCard],
];

export function pickFormIcon(name: string): LucideIcon {
  for (const [pattern, icon] of ICON_KEYWORDS) {
    if (pattern.test(name)) return icon;
  }
  return FileText;
}

const AVATAR_TONES = [
  "bg-[#ede9ff] text-[#eb6834]",
  "bg-blue-50 text-blue-600",
  "bg-green-50 text-success",
  "bg-amber-50 text-warning",
  "bg-pink-50 text-pink-600",
];

export function avatarTone(index: number): string {
  return AVATAR_TONES[index % AVATAR_TONES.length];
}

export function pctChange(current: number, previous: number): { value: number; direction: "up" | "down" } {
  if (previous === 0) {
    return { value: current > 0 ? 100 : 0, direction: current >= previous ? "up" : "down" };
  }
  const change = ((current - previous) / previous) * 100;
  return { value: Math.abs(Math.round(change * 10) / 10), direction: change >= 0 ? "up" : "down" };
}
